// extracted by mini-css-extract-plugin
export var infoRow = "_pq-2";
export var labelContainer = "_pq-0";
export var rightInfo = "_pq-1";